import { Controller } from '@hotwired/stimulus';

function scrollTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export default class extends Controller {
  static targets = ['scrollUp', 'tab', 'tabContent', 'searchModal', 'homepageSearch'];

  connect() {
    console.log('nav connect', this.element);

    if (this.hasTabContentTarget) {
      const tabContent = this.tabContentTarget;
      this.updateSelectedTabClass(tabContent.dataset.tabId);
    }

    if (this.hasSearchModalTarget) {
      const searchModal = this.searchModalTarget;
      searchModal.querySelector('input').addEventListener('blur', function () {
        setTimeout(() => searchModal.classList.remove('show'), 100);
      });
    }

    this.addOnScroll();
  }

  selectTab(e) {
    this.updateSelectedTabClass(e.currentTarget.dataset.selectTabId);
  }

  updateSelectedTabClass(tabId) {
    this.tabTargets.forEach((tab) => {
      if (tab.dataset.selectTabId == tabId) {
        tab.classList.add('selected');
      } else {
        tab.classList.remove('selected');
      }
    });
  }

  addOnScroll() {
    const hasScrollUp = this.hasScrollUpTarget;
    let scrollUpTarget;

    if (hasScrollUp) {
      scrollUpTarget = this.scrollUpTarget;
    }

    function onScroll() {
      if (hasScrollUp) {
        if (window.scrollY > 100) {
          scrollUpTarget.classList.add('show');
        } else {
          scrollUpTarget.classList.remove('show');
        }
      }
    }

    window.addEventListener('scroll', onScroll);
    onScroll();
  }

  scrollTop() {
    scrollTop();
  }

  back(event) {
    // Use Turbo navigation instead of window.history.back() to ensure proper styling
    if (window.history.length > 1) {
      // If there's history to go back to, use Turbo to navigate back
      Turbo.visit(document.referrer || '/', { action: 'advance' });
    } else {
      // Fallback to home page if no referrer
      Turbo.visit('/', { action: 'advance' });
    }
    event.preventDefault();
  }

  confirm(event) {
    if (!confirm(event.target.dataset.confirmMessage)) {
      event.preventDefault();
    }
  }

  searchFocusHandler(event) {
    this.toggleSearchModal(event);
  }

  toggleSearchModal(event) {
    if (this.hasHomepageSearchTarget) {
      this.homepageSearchTarget.querySelector('input').focus();
    } else {
      this.searchModalTarget.classList.toggle('show');
      this.searchModalTarget.querySelector('input').focus();
    }
  }
}
